// src/components/fun/messages/RandomMessage.jsx
import React from "react";
import { advices, quotes, memes } from "./messagesData";

const messages = [
  ...advices.map((text) => ({ type: "Порада", text })),
  ...quotes.map((text) => ({ type: "Цитата", text })),
  ...memes.map((text) => ({ type: "Мем", text })),
];

// Доступні анімації
const animations = [
  "animate-typing overflow-hidden whitespace-nowrap border-r-2 border-primary",
  "animate-fade-in whitespace-normal break-words",
  "animate-slide-up whitespace-normal break-words"
];

export default function RandomMessage() {
  const random = messages[Math.floor(Math.random() * messages.length)];
  
  // Обираємо випадкову анімацію
  const animation = animations[Math.floor(Math.random() * animations.length)];

  return (
    <div
      className="mt-6 border-l-4 border-primary pl-4 text-left w-full max-w-2xl mx-auto
                 bg-white dark:bg-zinc-900 
                 text-zinc-800 dark:text-zinc-200
                 border-zinc-300 dark:border-zinc-700
                 rounded-md py-3"
    >
      <h4 className="text-sm font-semibold text-primary dark:text-primary/80 mb-1">
        💡 {random.type}
      </h4>
      <p className={`text-base text-muted-foreground dark:text-zinc-400 italic ${animation}`}>
        {random.text}
      </p>
    </div>
  );
}
